import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Picker } from './Picker';
export const DayPicker = ({ year, month, label = 'Day', placeHolder = 'Please Select Day', ...props }) => {
    const dayItems = useMemo(() => {
        if (year && month) {
            const daysInMonth = new Date(year, month, 0).getDate();
            const days = new Array(daysInMonth).fill(1).map((day, index) => day + index);
            days.unshift(undefined);
            return days.map((day) => {
                return day === undefined
                    ? {
                        label: placeHolder,
                        value: undefined,
                    }
                    : { label: day.toString(), value: day };
            });
        }
        else {
            return [];
        }
    }, [year, month]);
    return _jsx(Picker, { ...props, items: dayItems, label: label });
};
